export { default as DynamicMap } from './DynamicGoogleMap';
export { default as StaticMap } from './StaticGoogleMap';
export { default as StartTripDynamicMap } from './StartTripDynamicGoogleMap';

export const isMapsLibLoaded = () => {
  return typeof window !== 'undefined' && window.google && window.google.maps;
};
